// ABOUTME: The steps of an application in the job page's stepper (the design's round markers and line), with the
// ABOUTME: state of each step, and "Schritt 4 von 5" above them.
import Box from '@mui/material/Box';
import { Text } from 'components/Text';
import { getTransWithParams } from 'modules/i18n';
import { ProcessStepper } from 'modules/jobListings/components/ProcessStepper';
import { TalentApplicationStep } from '../types';
import { stepPosition, trackerSteps } from '../utils';

/** Draws the steps trackerSteps leaves, as the full tracker does, by the same rules (#484). */
export const StepList = ({
  steps: given
}: {
  steps: TalentApplicationStep[];
}) => {
  const steps = trackerSteps(given);
  if (!steps.length) return null;
  const position = stepPosition(given);

  return (
    <Box data-testid="application-steps" sx={{ mb: 1 }}>
      {position && (
        <Text
          variant="caption"
          color="text.secondary"
          component="p"
          data-testid="application-step-position"
          sx={{ mb: 0.5 }}
        >
          {getTransWithParams('applications.detail.stepOf', {
            current: position.current,
            total: position.total
          })}
        </Text>
      )}
      <ProcessStepper steps={steps} stepTestId="application-step" />
    </Box>
  );
};
